import React, { useEffect, useState } from 'react'
import { match, Redirect } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FormData, formDataFromItem, formDataToItem } from "./types";
import { fromApi, Item, ItemDownload, Photo, Photos, toApi } from "_types/item";
import { errorMessage, makeRequest, useRequest } from "_utils/request";
// import { useUnloadListener } from "_utils/useUnloadListener";

import { EditItemMeta } from "./EditItemMeta";
import { EditItemPhoto } from "./EditItemPhoto";
// import { EditItemDocs } from './EditItemDocs'
import { EditItemDescription } from "./EditItemDescription";

import {
  // Alert,
  // ConfirmButton,
  Loader, Pane,
} from '_components'

import './EditItem.sass'

type DownloadError = "404";
const downloadErrorMessages = new Map<DownloadError, string>([
  ["404", "Requested instrument does not exist in our database."]
]);

interface DownloadProps {
  uuid: string;
  onSuccess: (item: Item) => void;
}

const Download: React.FC<DownloadProps> = ({ uuid, onSuccess }) => {
  const [result] = useRequest<ItemDownload, DownloadError>(
    makeRequest(`/instruments/${uuid}`),
    response => response.status === 404 ? "404" : null
  );

  useEffect(() => {
    if (result.kind === "success") onSuccess(fromApi(result.payload));
  });

  switch (result.kind) {
    case "error":
      return <h1>{errorMessage(result.error, downloadErrorMessages)}</h1>
    default:
      return <Loader />
  }
}

// export class OldEditItem extends React.Component {
//   handleCommit = () => {
//     const { itemValidation } = this.state
//     const allValid = Object.values(itemValidation).every(v => !v)
//     if (allValid) {
//       // this.props.dispatch(updateItem.updateItem({item}))
//       //   .then(() => {
//       //       // TODO: add individual confirmation for all the fields modified as well as list them in this notificaiton
//       //       this.props.dispatch(issueNotification(`Successfully modified ${meta.model} (${meta.serialNumber})`, 'success'))
//       //       this.props.history.push('/browse')
//       //   }).catch()
//     } else {
//       this.setState({submittedWithErrors: true})
//     }
//   }
//
//   handleDiscard = () => this.props.history.push('/browse')
//
//   render() {
//     const { item, itemValidation, itemDataModified } = this.state
//     const { meta } = item.data
//     const { is_fetching, error } = this.props.request
//
//     return (
//       <div className="pane">
//         <div className="action-buttons">
//           <ConfirmButton disabled={is_fetching} onConfirm={this.handleDiscard} confirm={itemDataModified}
//             contextualClass='warning'
//             icon='times'
//             button='Discard changes'
//             body='Changes will not be saved.'
//             ok='Discard changes'
//             cancel='Continue editing'
//           />
//         </div>
//       </div>
//     )
//   }
// }

interface EditProps {
  item: Item;
  onSubmit: (item: Item) => void;
}

const Edit: React.FC<EditProps> = ({ item, onSubmit }) => {
  // const setRegister = useUnloadListener();

  const [photoCollection, setPhotoCollection] = useState<Photo[]>(item.photos.collection);
  const [photoOrder, setPhotoOrder] = useState<string[]>(item.photos.order);

  const {register, handleSubmit, control, errors} = useForm<FormData>({defaultValues: formDataFromItem(item)});

  return <Pane>
    <h1>{`${item.meta.model} (${item.meta.serialNumber})`}</h1>
    <div className="EditItem"><form>
      <EditItemMeta register={register} errors={errors} />
      <EditItemDescription control={control} />
      <EditItemPhoto endpoint={`/instruments/${item.uuid}/photo`}
                     collection={photoCollection} setCollection={setPhotoCollection}
                     order={photoOrder} setOrder={setPhotoOrder}
      />
    </form></div>

    <button className="btn btn-primary" onClick={handleSubmit(data => onSubmit(
      formDataToItem(item.uuid, data, {collection: photoCollection, order: photoOrder} as Photos)
    ))}><FontAwesomeIcon icon='check' />&ensp;Save</button>
  </Pane>
}

interface UploadProps {
  item: Item;
}

const Upload: React.FC<UploadProps> = ({ item }) => {
  const request = makeRequest(`/instruments/${item.uuid}`, "PUT", toApi(item));
  const [result, fetchResult] = useRequest(request);

  switch (result.kind) {
    case "success":
      return <Redirect to="/" />
    case "error":
      return <div>
        <h1>{errorMessage(result.error)}</h1>
        <button className="btn btn-primary" onClick={() => fetchResult(request)}>Try again</button>
      </div>
    default:
      return <Loader />
  }
}

interface EditItemParams {uuid: string;}
interface EditItemProps {match: match<EditItemParams>;}

export const EditItem: React.FC<EditItemProps> = ({ match }) => {
  type DownloadState = {kind: "download", uuid: string};
  type EditState = {kind: "edit", item: Item};
  type UploadState = {kind: "upload", item: Item};

  type State = DownloadState | EditState | UploadState;
  const [state, setState] = useState<State>({kind: "download", uuid: match.params.uuid} as DownloadState);

  switch (state.kind) {
    case "download":
      return <Pane>
        <Download uuid={state.uuid} onSuccess={(item: Item) => setState({kind: "edit", item} as EditState)} />
      </Pane>
    case "edit":
      return <Edit item={state.item} onSubmit={(item: Item) => setState({kind: "upload", item} as UploadState)}/>
    case "upload":
      return <Pane>
        <Upload item={state.item} />
      </Pane>
  }
}
